export const CONTACT_ROLE_OPTIONS = [
  { value: 'Seller',       label: 'Seller'       },
  { value: 'Wholesaler',   label: 'Wholesaler'   },
  { value: 'Buyer Agent',  label: 'Buyer Agent'  },
  { value: 'Seller Agent', label: 'Seller Agent' },
  { value: 'Other',        label: 'Other'        },
]
